export const ACTIONS = {
  SCREEN_DISPLAYED: 'ScreenDisplayed',
  MODAL_WINDOW_DISPLAYED: 'ModalWindowDisplayed',
  CONTROL_BUTTON_CLICKED: 'ControlButtonClicked',
  CONTROL_HYPERLINK_CLICKED: 'ControlHyperLinkClicked',
  CONTROL_ACCORDION_EXPANDED: 'ControlAccordianExpanded',
  CONTROL_ACCORDION_COLLAPSED: 'ControlAccordianCollapsed',
  CONTROL_DISPLAYED: 'ControlDisplayed',
  CONTROL_TOGGLE_ENABLED: 'ControlToggleEnabled',
  CONTROL_TOGGLE_DISABLED: 'ControlToggleDisabled'
}
